<template>
  <div class="call-to-action-modern-area ptb--100" :style="backgroundStyle">
    <v-container>
      <v-row class="justify-center text-center">
        <v-col cols="12" md="10" lg="8">
          <div class="call-to-action-modern-card glass-premium rounded-3xl pa-8 pa-md-12">
            
            <div class="gradient-glow-aura"></div>
            

            <div class="modern-content-wrapper position-relative">
              <h2 v-if="style.ThemeHomeCallToAction?.Titulo?.Texto" class="modern-heading-title mb-4" :style="titleStyle">
                {{ style.ThemeHomeCallToAction.Titulo.Texto }}
              </h2>
              
              <v-divider class="mx-auto short-accent-divider mb-6" :style="{ '--divider-color': style.ThemeHomeCallToAction?.Titulo?.css?.Color || '#3949ab' }"></v-divider>
              
              <p v-if="style.ThemeHomeCallToAction?.Subtitulo?.Texto" class="modern-subtitle mb-8" :style="subtitleStyle">
                {{ style.ThemeHomeCallToAction.Subtitulo.Texto }}
              </p>
              
              <div class="mt-8" v-if="style.ThemeHomeCallToAction?.Button?.Texto">
                <a v-if="isExternalLink" :href="style.ThemeHomeCallToAction.Button.Url" target="_blank" class="notin-modern-btn" :style="buttonStyle">
                  {{ style.ThemeHomeCallToAction.Button.Texto }}
                  <v-icon right size="18" class="ml-2">mdi-arrow-right</v-icon>
                </a>
                <NuxtLink v-else :to="style.ThemeHomeCallToAction.Button.Url || '/'" class="notin-modern-btn" :style="buttonStyle">
                  {{ style.ThemeHomeCallToAction.Button.Texto }}
                  <v-icon right size="18" class="ml-2" :color="style.ThemeHomeCallToAction?.Button?.css?.Color || '#FFFFFF'">mdi-arrow-right</v-icon>
                </NuxtLink>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useStyles } from '../../store/styles';
const style = useStyles();

const backgroundStyle = computed(() => {
  const css = style.ThemeHomeCallToAction?.FondoCSS;
  if (!css) return {};
  return {
    backgroundColor: css.BackgroundColor || '#f5f8fa'
  };
});

const titleStyle = computed(() => {
  const css = style.ThemeHomeCallToAction?.Titulo?.css;
  if (!css) return {};
  return {
    color: css.Color || '#000000',
    fontFamily: css.Font || 'Montserrat',
    fontSize: css.Size || '38px',
    fontWeight: css.Weight || 800,
    textAlign: css.Align || 'center'
  };
});

const subtitleStyle = computed(() => {
  const css = style.ThemeHomeCallToAction?.Subtitulo?.css;
  if (!css) return {};
  return {
    color: css.Color || '#555555',
    fontFamily: css.Font || 'Montserrat',
    fontSize: css.Size || '20px',
    fontWeight: css.Weight || 400,
    textAlign: css.Align || 'center'
  };
});

const buttonStyle = computed(() => {
  const css = style.ThemeHomeCallToAction?.Button?.css;
  if (!css) return {};
  return {
    color: css.Color || '#FFFFFF',
    backgroundColor: css.BackgroundColor || '#000000',
    fontFamily: css.Font || 'Montserrat',
    fontSize: css.Size || '16px',
    fontWeight: css.Weight || 600,
    textAlign: css.Align || 'center',
    border: css.BorderColor ? `2px solid ${css.BorderColor}` : (css.Color ? `2px solid ${css.Color}` : '2px solid transparent'),
    padding: '16px 36px',
    borderRadius: '50px', // Pill shape for modern look
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    transition: 'all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1)',
    boxShadow: `0 8px 20px ${css.BackgroundColor ? css.BackgroundColor + '40' : 'rgba(0,0,0,0.15)'}`
  };
});

const isExternalLink = computed(() => {
  const url = style.ThemeHomeCallToAction?.Button?.Url;
  if (!url) return false;
  return url.startsWith('http://') || url.startsWith('https://');
});
</script>

<style scoped lang="scss">
.call-to-action-modern-area {
  position: relative;
  overflow: hidden;
}

.call-to-action-modern-card {
  position: relative;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.03);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.05);
  transition: all 0.5s ease;
  overflow: hidden;
  z-index: 1;

  &.glass-premium {
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    background: rgba(255, 255, 255, 0.9);
  }

  &:hover {
    box-shadow: 0 30px 60px rgba(0, 0, 0, 0.08);
    transform: translateY(-5px);

    .gradient-glow-aura {
      transform: scale(1.1) rotate(5deg);
      opacity: 0.15;
    }
    
    .modern-graphic-watermark svg {
      transform: rotate(15deg) scale(1.1);
    }
  }
}

.gradient-glow-aura {
  position: absolute;
  inset: -20px;
  background: linear-gradient(135deg, var(--divider-color, #3949ab), #1a237e);
  filter: blur(40px);
  opacity: 0.06;
  border-radius: 40px;
  transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: -1;
  pointer-events: none;
}

.modern-graphic-watermark {
  position: absolute;
  top: -40px;
  left: -40px;
  width: 200px;
  height: 200px;
  color: var(--divider-color, #3949ab);
  pointer-events: none;
  z-index: 0;
  
  svg {
    width: 100%;
    height: 100%;
    transition: transform 0.8s ease;
  }
}

.modern-content-wrapper {
  z-index: 2;
}

.modern-heading-title {
  letter-spacing: -0.5px;
  line-height: 1.2;
}

.short-accent-divider {
  width: 80px;
  border-width: 3px !important;
  border-color: var(--divider-color, #3949ab) !important;
  opacity: 0.9;
  border-radius: 3px;
}

.modern-subtitle {
  line-height: 1.6;
  max-width: 80%;
  margin: 0 auto;
}

.notin-modern-btn {
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 25px rgba(0,0,0,0.2) !important;
    
    &::after {
      left: 120%;
    }
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 50%;
    height: 100%;
    background: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0.2) 50%, rgba(255,255,255,0) 100%);
    transform: skewX(-25deg);
    transition: left 0.7s ease;
  }
}

@media (max-width: 768px) {
  .call-to-action-modern-card {
    padding: 30px 20px !important;
  }
  .modern-heading-title {
    font-size: 28px !important;
  }
  .modern-subtitle {
    font-size: 16px !important;
    max-width: 100%;
  }
}
</style>
